import {
  IS_LOADING,
  LOAD_USER_ATTRIBUTES,
  USER_DATA_LOAD,
  SET_ACTIVE_CATEGORY,
  TOGGLE_MINI_MODE
} from '../constants/';


const ls = window.localStorage;

const initialState = {
  isLoading: false,
  miniMode: ls.getItem('miniMode') === "true"
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case IS_LOADING:
      return { ...state, isLoading: action.payload };
    case USER_DATA_LOAD:
      return { ...state, userData: action.payload };
    case LOAD_USER_ATTRIBUTES:
      return { ...state, userAttributes: action.payload };
    case SET_ACTIVE_CATEGORY:
      return { ...state, activeCategory: action.payload };
    case TOGGLE_MINI_MODE:
      return { ...state, miniMode: action.payload };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/utils/store/appReducer.js